// extracted by mini-css-extract-plugin
export var locationsModal = "_redotech-redo-customer-portal-app-lib-portal-four-returns-components-return-locations-button-locations-modal";